define('core/views/common/LoginFormView',[
    'underscore',
    'backbone',

    'core/strings',
], function (
    _,
    Backbone,

    strings
) {
    'use strict';

    var gettext = strings.get;

    /**
     * A parent class for LoginFormViews. Contains common functionality.
     * Intented to be extended, not instantiated.
     *
     * Requires children to define the following:
     *     handleRegistrationError: function (errors)
     *         given an mapping from attribute name to list of errors
     *     handleRegistrationSuccess: function ()
     *         called upon sync success
     *     render: function ()
     *         renders the template
     *     User: Model
     *         the project-specific User model
     */
    var LoginFormView = Backbone.View.extend({
        initialize: function () {
            this.model = new this.User();
        },

        /**
         * Make the API response look like a validation error.
         *
         * Validation errors are {<attribute name>: [Array of errors]}.
         *
         * @param  {Object} response Registration error response from API.
         * @returns {Object}          Validation error object.
         */
        parseRegistrationErrorResponse: function (response) {

            if (!response.responseJSON)
                return;

            var errorText = response.responseJSON.response;

            if (window.grecaptcha)
                window.grecaptcha.reset();

            if (/Unable to create user/i.test(errorText)) {
                return {
                    email: [gettext(
                        'That email address is already registered with a Disqus account. Log in or enter another email.'
                    )],
                };
            }

            if (/The e-mail address you specified is already in use./i.test(errorText)) {
                return {
                    email: [
                        gettext('The e-mail address you specified is already in use.') +
                            '<br><a class="link" href="#" data-action="auth:disqus">' +
                            gettext('Try logging in.') + '</a>',
                    ],
                };
            }

            if (/You must re-submit this request with a response to the captcha challenge/i.test(errorText) && this.showCaptcha)
                this.showCaptcha(null, true);

            return {
                all: [errorText],
            };
        },

        getPassword: function () {
            // normalize password
            var password = this.$el.find('input[name=password]');
            if (password.length)
                return password.val();

            return null;
        },

        getDisplayName: function () {
            return this.$el.find('input[name=display_name]').val();
        },

        getEmail: function () {
            return this.$el.find('input[name=email]').val();
        },

        disableForm: function () {
            this.$('[data-role=submit-btn-container]').addClass('is-submitting');
        },

        enableForm: function () {
            this.$('[data-role=submit-btn-container]').removeClass('is-submitting');
        },

        handleRegistrationErrorResponse: function (response) {
            this.handleRegistrationError(this.parseRegistrationErrorResponse(response));
        },

        registerUser: function () {
            this.model.set({
                display_name: this.$el.find('input[name=display_name]').val(),
                email: this.$el.find('input[name=email]').val(),
                password: this.getPassword(),
            });

            // Client-side validation first
            if (!this.model.isValid())
                return void this.handleRegistrationError(this.model.validationError);

            this.disableForm();

            this.model.register({
                gRecaptchaResponse: this.captchaShown && window.grecaptcha && window.grecaptcha.getResponse(),
                error: _.bind(this.handleRegistrationErrorResponse, this),
                success: _.bind(this.handleRegistrationSuccess, this),
            }).always(_.bind(this.enableForm, this));
        },
    });

    return LoginFormView;
});

